import React from "react";
import { Autocomplete, Box, Chip, Paper, Stack, TextField, Typography } from "@mui/material";
import DiscountOverview from "../DiscountOverview/DiscountOverview";
import SelectedProductSummary from "./SelectedProductSummary/SelectedProductSummary";

const BarcodeInput = ({ label, dataKey, currentValues, setValue }) => {
	const updateBarcodes = (key, newBarcodes) => {
		setValue((prev) => ({
			...prev,
			product_selection: {
				...prev.product_selection,
				[key]: newBarcodes,
			},
		}));
	};
	const handlePaste = (e) => {
		e.preventDefault();
		const paste = e.clipboardData.getData("text");
		if (!paste) return;

		const newItems = paste
			.split(/[\n\r\s,]+/)
			.map((item) => item.trim())
			.filter((item) => item !== "");

		const uniqueNewItems = [...new Set(newItems)].filter((item) => !currentValues.includes(item));

		if (uniqueNewItems.length > 0) {
			updateBarcodes(dataKey, [...currentValues, ...uniqueNewItems]);
		}
	};

	return (
		<Box width={"47%"} display={"flex"} flexDirection={"column"}>
			<Typography gutterBottom>{label}</Typography>
			<Autocomplete
				sx={{ maxHeight: "50px" }}
				multiple
				freeSolo
				limitTags={2}
				getLimitTagsText={() => "..."}
				options={[]}
				value={currentValues}
				onChange={(event, newValue) => {
					updateBarcodes(dataKey, [...new Set(newValue)]);
				}}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" />)
				}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						placeholder="Enter or Paste barcodes"
						onPaste={handlePaste}
						sx={{
							"& .MuiInputBase-root": {
								// maxHeight: "300px",
								// overflowY: "scroll",
								// alignContent: "flex-start",
							},
						}}
					/>
				)}
			/>
		</Box>
	);
};

function ProductSelectionSection({ value, setValue }) {
	return (
		<Box>
			<Box display="flex" gap={1} flexWrap="wrap" pl={2}>
				<BarcodeInput
					label="Discount Barcodes"
					dataKey="discount_product"
					currentValues={value?.product_selection?.discount_product || []}
					setValue={setValue}
				/>
				<BarcodeInput
					label="NOD Barcodes"
					dataKey="nod"
					currentValues={value?.product_selection?.nod || []}
					setValue={setValue}
				/>
			</Box>
			<Box pt={3}>
				<SelectedProductSummary
					barcodes={value?.product_selection?.discount_product || []}
					nod_barcdes={value?.product_selection?.nod || []}
				/>
			</Box>
		</Box>
	);
}

export default ProductSelectionSection;
